<template id="customer-drilldown">
    <section>
        <div class="row">
            <div class="col-md-10 col-lg-12 text-center mt-3 mb-5">
                <div class="card">
                    <div class="card-header text-left">
                        Customer Drilldown
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover">
                                <thead class="thead-dark" align="center">
                                <tr>
                                    <th></th>
                                    <th>{{repDataDp[0].rd1_id}}</th>
                                    <th>{{repDataDp[0].rd1}}</th>
                                    <th>{{repDataDp[0].rd2}}</th>
                                    <th>{{repDataDp[0].rm1}}</th>
                                    <th>{{repDataDp[0].rm2}}</th>
                                    <th>{{repDataDp[0].rm3}}</th>
                                    <th>{{repDataDp[0].rm4}}</th>
                                    <th>Action</th>
                                    <th>Assign</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(c,idx) of customerData">
                                    <tr v-bind:key="idx">
                                        <td><a href="#" @click="loadLevelOne(c.rd1Id)"><span
                                                class="offset-md-0">+</span></a>
                                        </td>
                                        <td>{{c.rd1Id}}</td>
                                        <td>{{c.rd1}}</td>
                                        <td>{{c.rd2}}</td>
                                        <td class="text-right">{{c.rm1}}</td>
                                        <td class="text-right">{{c.rm2}}</td>
                                        <td class="text-right">{{c.rm2-c.rm3}}</td>
                                        <td class="text-right">{{(((c.rm2-c.rm3)*100)/c.rm2).toFixed(2)}}</td>
                                        <td><a @click="commentBox('Retailer Drilldown', 'drilldown_report')">
                                            <i class="fa fa-tags text-primary"></i>
                                        </a>
                                            <a @click="assignModal('retailer_view', c.retailer_id)">
                                                <i class="fa fa-user-cog text-info"></i>
                                            </a></td>
                                        <td><span v-if="c.assign==null">- NA -</span>
                                            <span v-if="c.assign!=null">{{c.assign}}</span></td>
                                    </tr>
                                    <tr v-if="whatL1 === c.rd1Id" class="table-info" v-bind:key="`c-${idx}`">
                                        <th></th>
                                        <th></th>
                                        <th><span class="offset-md-1">{{repDataDp[0].rd1L1}}</span></th>
                                        <th></th>
                                        <th>{{repDataDp[0].rm1}}</th>
                                        <th>{{repDataDp[0].rm2}}</th>
                                        <th>{{repDataDp[0].rm3}}</th>
                                        <th>{{repDataDp[0].rm4}}</th>
                                        <th>Action</th>
                                        <th>Assign</th>
                                    </tr>
                                    <template v-for="(first,idx) of firstDrilldownData">
                                        <tr v-bind:key="`first-${idx}`" v-if="whatL1 === c.rd1Id">
                                            <td>
                                                <a href="#" @click="loadLevelTwo(c.rd1Id, first.rd1l1)">
                                                    <span class="offset-md-2">&gt;&gt;</span>
                                                </a>
                                            </td>
                                            <td colspan="1">&nbsp;</td>
                                            <td><span class="offset-md-1" v-b-tooltip.hover
                                                      title="Product Category">{{first.rd1l1}}</span>
                                            </td>
                                            <td></td>
                                            <td class="text-right"><span
                                                    v-b-tooltip.hover title="Transaction">{{first.rm1}}</span></td>
                                            <td class="text-right"><span
                                                    v-b-tooltip.hover title="Sale Amount">{{first.rm2}}</span></td>
                                            <td class="text-right"><span v-b-tooltip.hover title="Margin">{{first.rm2-first.rm3}}</span>
                                            </td>
                                            <td class="text-right">
                                                <span v-b-tooltip.hover title="Margin%">{{(((first.rm2-first.rm3)*100)/first.rm2).toFixed(2)}}</span>
                                            </td>
                                            <td><a @click="commentBox('Retailer Drilldown', 'drilldown_report')">
                                                <i class="fa fa-tags text-primary"></i>
                                            </a>
                                                <a @click="assignModal('retailer_view', p.retailer_id)">
                                                    <i class="fa fa-user-cog text-info"></i>
                                                </a></td>
                                            <td v-b-tooltip.hover title="Assign">
                                                <span data-ng-if="c.assign==null">- NA -</span>
                                                <span data-ng-if="c.assign!=null">{{c.assign}}</span>
                                            </td>
                                        </tr>
                                        <tr v-if="whatL1 === c.rd1Id && whatL2 === first.rd1l1" class="table-primary"
                                            v-bind:key="`second-${idx}`">
                                            <th></th>
                                            <th></th>
                                            <th><span class="offset-lg-2">{{repDataDp[0].rd1L2}}</span></th>
                                            <th></th>
                                            <th>{{repDataDp[0].rm1}}</th>
                                            <th>{{repDataDp[0].rm2}}</th>
                                            <th>{{repDataDp[0].rm3}}</th>
                                            <th>{{repDataDp[0].rm4}}</th>
                                            <th>Action</th>
                                            <th>Assign</th>
                                        </tr>
                                        <template v-for="(snd,idx) of secondDrilldownData">
                                            <tr v-bind:key="`second2-${idx}`"
                                                v-if="whatL1 === c.rd1Id && whatL2 === first.rd1l1">
                                                <td><span class="offset-md-3">&#8680;</span></td>
                                                <td></td>
                                                <td><span class="offset-lg-2">{{snd.rd1l2}}</span></td>
                                                <td></td>
                                                <td class="text-right">{{snd.rm1}}</td>
                                                <td class="text-right">{{snd.rm2}}</td>
                                                <td class="text-right">{{snd.rm2-snd.rm3}}</td>
                                                <td class="text-right">
                                                    {{(((snd.rm2-snd.rm3)*100)/snd.rm2).toFixed(2)}}
                                                </td>
                                                <td><a @click="commentBox('Retailer Drilldown', 'drilldown_report')">
                                                    <i class="fa fa-tags text-primary"></i>
                                                </a>
                                                    <a @click="assignModal('retailer_view', p.retailer_id)">
                                                        <i class="fa fa-user-cog text-info"></i>
                                                    </a></td>
                                                <td>
                                                    <span data-ng-if="c.assign==null">- NA -</span>
                                                    <span data-ng-if="c.assign!=null">{{c.assign}}</span>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>

                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'

export default {
    name: 'customer-drilldown',
    data: function () {
      return {
        customerData: [],
        firstDrilldownData: [],
        secondDrilldownData: [],
        retid: [],
        whatL1: null,
        whatL2: null,
        level1: [],
        level2: [],
        repDataDp: []
      }
    },
    created: function () {
      this.loadCustomer(),
        this.loadSummary()
    },

    methods: {
      loadSummary: async function () {
        let menuParam = this.$route.params.submenuId
        this.$store.dispatch("loadState").then(() => {
          let allRepData = this.$store.state.reportScreenConfig
          console.log('Testing All Datas', this.allRepData)
          this.repDataDp = allRepData.filter(r => r.repId === 1 && r.reportingMetadataRow === 'DisplayName')
          console.log('Testing All repDataDp', this.repDataDp)
          this.repData = allRepData.filter(r => r.repId === 1 && r.reportingMetadataRow === 'Data')
          console.log('Testing All repData', this.repData)
          this.repDataTp = allRepData.filter(r => r.repId === 1 && r.reportingMetadataRow === 'ToolTip')//Let is used in headmap .vue here this is used
          console.log('Testing All repDataTp', this.repDataTp)
        }, err => {
          console.log('Error in getting data', err)
        })
        const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
        console.log("menuDetails",menuDetails);
        await this.$commonFn.auditLog(menuDetails[0].syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "GET", "Success")
      },
      //For Loading the Customer Details
      //Get Request
      loadCustomer: function () {
        let url = '/api/level0Data/1/Data'
        axios.get(url)
          .then(res => {
            this.customerData = res.data
            console.log('Testing Initial Data', this.customerData)
          }, err => {
            console.log('Error in fetching record', err)
          })
      },
      loadLevelOne: function (l1) {
        console.log('Level 1 Data', this.l1)
        if (this.whatL1 === l1) {
          this.whatL1 = null
        } else {
          this.whatL1 = l1
        }
        let url = '/api/level1Data/1/Data/' + l1
        axios.get(url)
          .then(res => {
            this.firstDrilldownData = res.data
            console.log('First DrillDown Data Are', this.firstDrilldownData)
          }, err => {
            console.error('error in fetching data', err)
          })
      },
      loadLevelTwo: function (l1, l2) {
        if (this.whatL2 === l2) {
          this.whatL2 = null
        } else {
          this.whatL2 = l2
        }
        let url = '/api/level2Data/1/Data/' + l1 + '/' + l2
        axios.get(url)
          .then(res => {
            this.secondDrilldownData = res.data
            console.log('Second DrillDown Data Are', this.secondDrilldownData)
          }, err => {
            console.error('error in fetching data', err)
          })
      }
    },
  }
</script>
<style>

</style>